import { ReactNode, useState } from "react";
import { Modal as AriaModal, ModalOverlay } from "react-aria-components";

export default function Modal({
  children,
  actionLabel,
  isModalDismissable = false,
  notClosable = false,
}: {
  children: ReactNode;
  actionLabel?: string;
  isModalDismissable?: boolean;
  notClosable?: boolean;
}) {
  const [isModalOpen, setIsModalOpen] = useState(true);

  return (
    <ModalOverlay
      isDismissable={!notClosable && isModalDismissable}
      isOpen={isModalOpen}
      onOpenChange={setIsModalOpen}
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background/50"
    >
      <AriaModal className="mx-10 flex h-fit  flex-col gap-2 rounded-3xl bg-white p-4 text-black shadow-lg">
        {children}
        {!notClosable && (
          <button
            className="mt-4 w-full rounded-xl bg-primary py-2 text-white"
            onClick={() => setIsModalOpen(!isModalOpen)}
          >
            {actionLabel}
          </button>
        )}
      </AriaModal>
    </ModalOverlay>
  );
}
